import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Amplify } from 'aws-amplify';
import 'bootstrap/dist/css/bootstrap.min.css';

 const parseCsvOrArray = (value) => {
   if (!value) return [];
   if (Array.isArray(value)) return value;
   return String(value)
     .split(',')
     .map((p) => String(p || '').trim())
     .filter(Boolean);
 };

 const extractFirstMatch = (allUris) => {
   const items = parseCsvOrArray(allUris);
   if (items.length === 0) return '';
   try {
     const { hostname, origin } = window.location;
     const match = items.find((uri) => {
       try {
         const url = new URL(uri);
         return url.hostname === hostname || url.origin === origin;
       } catch {
         return false;
       }
     });
     return match || items[0];
   } catch {
     return items[0];
   }
 };

 const stashPosCallbackParams = () => {
   try {
     if (typeof window === 'undefined') return;
     const pathname = String(window.location?.pathname || '');
     if (pathname !== '/admin/channels/pos/callback') return;

     const url = new URL(window.location.href);
     const code = String(url.searchParams.get('code') || '').trim();
     const state = String(url.searchParams.get('state') || '').trim();
     const err = String(url.searchParams.get('error') || '').trim();
     const merchantId = String(url.searchParams.get('merchant_id') || url.searchParams.get('merchantId') || '').trim();
     const clientId = String(url.searchParams.get('client_id') || url.searchParams.get('clientId') || '').trim();
     const environment = String(url.searchParams.get('environment') || '').trim();
     const provider = String(url.searchParams.get('provider') || '').trim();

     const shouldStash = Boolean(code || state || err || merchantId || clientId);
     if (!shouldStash) return;

     try {
       if (code) window.sessionStorage?.setItem('pos_connect_code', code);
       if (state) window.sessionStorage?.setItem('pos_connect_state', state);
       if (err) window.sessionStorage?.setItem('pos_connect_error', err);
       if (merchantId) window.sessionStorage?.setItem('pos_connect_merchant_id', merchantId);
       if (clientId) window.sessionStorage?.setItem('pos_connect_client_id', clientId);
       if (environment) window.sessionStorage?.setItem('pos_connect_environment', environment);
       if (provider) window.sessionStorage?.setItem('pos_connect_provider', provider);
     } catch {
     }

     url.searchParams.delete('code');
     url.searchParams.delete('state');
     url.searchParams.delete('error');
     url.searchParams.delete('merchant_id');
     url.searchParams.delete('merchantId');
     url.searchParams.delete('client_id');
     url.searchParams.delete('clientId');
     url.searchParams.delete('environment');
     url.searchParams.delete('provider');
     window.history.replaceState({}, document.title, `${url.pathname}${url.search ? url.search : ''}${url.hash || ''}`);
   } catch {
   }
 };

 stashPosCallbackParams();

// Configure Amplify
Amplify.configure({
  Auth: {
    region: process.env.REACT_APP_AWS_REGION,
    userPoolId: process.env.REACT_APP_AWS_USER_POOL_ID,
    userPoolWebClientId: process.env.REACT_APP_AWS_USER_POOL_CLIENT_ID,
    oauth: {
      domain: process.env.REACT_APP_AWS_OAUTH_DOMAIN,
      scope: ['openid', 'email', 'profile'],
      redirectSignIn: extractFirstMatch(process.env.REACT_APP_AWS_REDIRECT_SIGN_IN),
      redirectSignOut: extractFirstMatch(process.env.REACT_APP_AWS_REDIRECT_SIGN_OUT),
      responseType: 'code'
    }
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
